






















import { nextTick, onMounted, ref } from 'vue';
import Icon from './Icon.vue';
import { iconClassEnum } from '../enums/iconClassEnum';

export default {
  name: 'ScrollShadowHorizontal',
  components: { Icon },
  setup() {
    const container = ref<HTMLElement | null>(null);
    const canMoveBackward = ref(false);
    const canMoveForward = ref(false);

    const updateShadows = () => {
      const el: HTMLElement = container.value;
      if (!el) {
        return;
      }

      const { scrollLeft, scrollWidth, clientWidth } = el;
      // Use a small tolerance (1px) to account for floating-point precision issues on Android
      const SCROLL_TOLERANCE = 1;

      canMoveBackward.value = scrollLeft > 0;
      canMoveForward.value = scrollLeft + clientWidth < scrollWidth - SCROLL_TOLERANCE;
    };

    const handleScroll = () => updateShadows();

    const scrollByAmount = (scrollDistance: number) => {
      container.value.scrollBy({
        left: scrollDistance,
        behavior: 'smooth',
      });
    };

    onMounted(async () => {
      await nextTick();
      updateShadows();

      const resizeObserver = new ResizeObserver(updateShadows);
      resizeObserver.observe(container.value);
    });

    return {
      container,
      canMoveBackward,
      canMoveForward,
      handleScroll,
      scrollByAmount,
    };
  },
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
  },
};
